import { render, staticRenderFns } from "./GroupedAvatars.vue?vue&type=template&id=222ce3ac&"
import script from "./GroupedAvatars.vue?vue&type=script&lang=js&"
export * from "./GroupedAvatars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports